/**
 * The current work order operation for the NATS labor flow, where the current
 * labor ticket is its only source: the ticket's operation, normalized, or null
 * when there is no ticket or the ticket has no operation (so a previous ticket's
 * job can't linger behind a different current ticket).
 * @param {object|null|undefined} laborTicket
 * @returns {object|null}
 */
export const workOrderOpFromLaborTicket = (laborTicket) => {
  const workOrderOperation = laborTicket?.workOrderOperation;
  if (!workOrderOperation) {
    return null;
  }

  const partOperation = workOrderOperation.matchingPartOperations?.[0];
  const partOperationCycleTimeMs = partOperation?.cycleTimeMs || 0;
  const quantityPerPart =
    partOperation?.quantityPerPart > 0 ? partOperation.quantityPerPart : 1;

  return {
    ...workOrderOperation,
    quantityPerPart,
    partOperation,
    partOperationRef: partOperation?.partOperationRef,
    // if no operation cycleTimeMs, use cycleTimeMs on partOperation
    cycleTimeMs: workOrderOperation.cycleTimeMs || partOperationCycleTimeMs,
  };
};
